import { render } from "./DeveloperModeToggle.vue?vue&type=template&id=0c36c6e7"
import script from "./DeveloperModeToggle.vue?vue&type=script&lang=js"
export * from "./DeveloperModeToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__